import { MatDialog } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import { FormControl } from '@angular/forms';
import { ShipyardService } from 'src/app/modules/shipyard/shipyard.service';
import { PlanyardService } from "src/app/modules/planyard/planyard.service";
import { Subject } from "rxjs";
import { SkuMappingEditComponent } from "src/app/modules/detail/presentational/sku-mapping-edit/sku-mapping-edit.component";
import { StorageKeyEnum } from "src/app/core/StorageKeyEnum";
import { takeUntil } from 'rxjs/operators';
import { ConfirmDialogComponent } from 'src/app/components/dialogs/confirm-dialog/confirm-dialog.component';
import { GridActionsService } from './../../../data-grid/grid-actions.service';
import { SkuDetail } from "../../../models/priceyard.model";
import { GridApi, GridOptions, IServerSideDatasource } from "@ag-grid-community/core";
import { MatSnackBar } from '@angular/material/snack-bar';
import { HeaderService } from 'src/app/components/header/header.service';
import { WalmartService } from 'src/app/services/walmart.service';
import { LoadingCellRendererComponent } from '../../loading-cell-renderer/loading-cell-renderer.component';
import { DateCellRendererComponent } from '../../date-cell-renderer/date-cell-renderer.component';
import { ShipmentNameCellRendererComponent } from '../../shipment-name-cell-renderer/shipment-name-cell-renderer.component';
import { OrderStatusCellRendererComponent } from '../../order-status-cell-renderer/order-status-cell-renderer.component';
import { CheckboxCellRendererComponent } from '../../checkbox-cell-renderer/checkbox-cell-renderer.component';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { updateIgnorePayload } from 'src/app/models/planyard.model';
import { GridReadyEvent } from '@ag-grid-community/core';
import { InventoryService } from 'src/app/services/inventory.service';


@Component({
  selector: "app-planyard-panel",
  templateUrl: "./planyard-panel.component.html",
  styleUrls: ["./planyard-panel.component.scss"],
})
export class PlanyardPanelComponent implements OnInit, OnDestroy {
  _selectedSku: SkuDetail;
  get selectedSku(): SkuDetail {
    return this._selectedSku;
  }
  totalStock;
  ignore:boolean = false

  @Input() set selectedSku(value: SkuDetail) {
    this._selectedSku = value;
    this.shipmentType.setValue(this.selectedSku.fbaType);
    this.gettingSkuMapping();      
  }
  shipmentType = new FormControl("");

  mappings;
  editEvent: EventEmitter<any> = new EventEmitter();
  isPlanyard: any;
  fbaTypes = this.shipyardService.getAllShipmentTypes();

  private destroy$ = new Subject<void>();
  gridApi: GridApi;
  startRow = 0;
  amountPerPage = 50;
  account;
  selectedService: any;
  isWalmart: boolean = false;
  shipments: any;
  _sku: any;
  @Input() get sku() {
    return this._sku;
  }
  set sku(value) {
    this._sku = value;
  }
  _accountSkuId: number;
  showSeasonalVelocity:boolean;
  suggestedAmount:number=0;
  roundedAmount:number=0;
  columnDefs = [
    {
      field: "amazonShipmentId",
      backendFields: ["amazonShipmentId","shipmentName"],
      cellRenderer: "shipmentNameCellRendererComponent",    
      headerName: "Shipment ID",
      width: 200,
      cellRendererParams: (params) => {
        return {
          fba:true,
        };
      },
    },
    {
      field: "totalQty",
      backendFields: ["totalQty"],
      width: 60,  
      headerName:'Qty',
      valueFormatter: (params) => {
        return params.value ? params.value.toFixed().toLocaleString('en') :  0;
      },      
    },
    {
      field: "status", 
      backendFields: ["status"],
      cellRenderer: "orderStatusCellRendererComponent",       
      width: 125,
      minWidth:120        
    },
     /*{
      field: "ignore",
      headerName: "Ignore",
      headerTooltip: "Ignore",
      sortable: true,
      cellRenderer: "checkboxCellRendererComponent",
      maxWidth: 50,
      width: 50,
      minWidth: 50,
      pinned:'right',
      cellRendererParams: {
        saveChanges: this.updateShipmentIgnore.bind(this),
      },
    },*/
  ];

  _routeName: any;
  @Input() get routeName() {
    return this._routeName;
  }
  set routeName(value) {
    this._routeName = value;
  }

  _selectedRow: any;
  @Input() get selectedRow() {
    return this._selectedRow;
  }
  set selectedRow(value) {
    this._selectedRow = value;
    this.financeSettlementData();
  }
  financeData:any;

  components = {
    loadingCellRenderer: LoadingCellRendererComponent,
    dateCellRendererComponent: DateCellRendererComponent,
    shipmentNameCellRendererComponent: ShipmentNameCellRendererComponent,
    orderStatusCellRendererComponent: OrderStatusCellRendererComponent,
    checkboxCellRendererComponent:CheckboxCellRendererComponent
  };
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sku.previousValue) {
      if (changes.sku.currentValue !== changes.sku.previousValue) {
        this.gridApi.setGridOption("serverSideDatasource", this.dataSource);;
      }
    }
  }
  gridOptions: GridOptions = {
    rowModelType: "serverSide",
    suppressServerSideInfiniteScroll: false,
    suppressCopyRowsToClipboard: true,
    rowHeight:58,
    cacheBlockSize: 50,
    defaultColDef: {
      resizable: true,
      sortable:false,
      filterParams: {
        maxNumConditions : 1,
      },
      menuTabs: ["filterMenuTab"],
    },
    components: this.components,
    rowSelection: "multiple",
    loadingCellRenderer: "loadingCellRenderer",
    onGridReady: (e:GridReadyEvent) => {
      this.gridApi = e.api;
      this.gridApi.setGridOption('columnDefs', this.columnDefs);
      this.gridApi.setGridOption("serverSideDatasource", this.dataSource);;
    },
    onGridSizeChanged: (e) => this.resized(),
  };
  constructor(
    private planyardService: PlanyardService,
    private headerService: HeaderService,
    private walmartService: WalmartService,
    private dialog: MatDialog,
    private gridActionsService: GridActionsService,
    private shipyardService: ShipyardService,
    private snackBar:MatSnackBar,
    private inventoryService: InventoryService
  ) { }
  dataSource: IServerSideDatasource = {
    getRows: (params: any) => {
      this.shipyardService
      .GetShipmentBreakdown(
        this.account,
        params.request.startRow,
        params.request.endRow,
        this._selectedSku.sku
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        response.forEach((el) => {
          el.Status = el.status;
        });
        if (!response.length) {
          this.gridApi.showNoRowsOverlay();
        } else {
          this.gridApi.hideOverlay();
        }
        params.success({
          rowData: response,
          rowCount: response.length < 50 ? response.length : null,
        });
      });
    }
  }

  ngOnInit(): void {
    this.gridActionsService.updateRemainigDays$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      if(res.value){
        this.selectedSku.replenishVelocity = res.value;
        this.totalStock = (this.selectedSku.replenishDays * this.selectedSku.replenishVelocity);
        let suggested = (this.totalStock - (this.selectedSku?.fbaStock || 0) - 
                          ((this.selectedSku?.amountInShipment || 0) + (this.selectedSku?.working || 0)) + (this.roundedAmount || 0));
         if(this.selectedSku?.amountDiffRepl && this.showSeasonalVelocity){
          this.suggestedAmount =  Math.trunc(suggested + this.selectedSku?.amountDiffRepl)
         }else{
          this.suggestedAmount = Math.trunc(suggested);
         }         
        this.shipyardService.seasonalValueChanged.next({amount:this.suggestedAmount,node:res.node,isUpdateSuggested:true})
      }      
    })
    this.shipyardService.seasonalValueChanged.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      if(res && !res.isUpdateSuggested){
        if(res.amount){
          this.roundedAmount=res.enforceValue ? res.enforceValue : this.selectedSku?.replenishByCase - this.selectedSku?.restock;
          this.suggestedAmount=res.amount;
          this.showSeasonalVelocity = true;
        } else{
          this.suggestedAmount=this.selectedSku?.replenishByCase;
          this.roundedAmount= this.selectedSku?.replenishByCase - this.selectedSku?.restock;
          this.showSeasonalVelocity = false;
        }
      }
    })
    this.roundedAmount= this.selectedSku?.replenishByCase - this.selectedSku?.restock;
    this.suggestedAmount=this.selectedSku?.replenishByCase;
    this.totalStock = (this.selectedSku.replenishDays * this.selectedSku.replenishVelocity);
    this.isPlanyard = JSON.parse(
      localStorage.getItem(StorageKeyEnum.User)
    ).isPlanYard;

    this.headerService.accountsSelected
    .pipe(takeUntil(this.destroy$))
    .subscribe((e) => {
      this.account = e;
    });
  this.headerService.accountSelectedType
    .pipe(takeUntil(this.destroy$))
    .subscribe((e) => {
      if (e) {
        this.isWalmart = e[0] === "Walmart";
        this.selectedService = this.isWalmart
          ? this.walmartService
          : this.shipyardService;
      }
    });
  }

  gettingSkuMapping() {
    this.planyardService
      .GetSkuMappings(this.selectedSku.accountSkuId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => (this.mappings = e));
  }

  financeSettlementData(){
    this.inventoryService
    .financeSettlementData(this.selectedRow[0].Orderid)
    .pipe(takeUntil(this.destroy$))
    .subscribe((e:any) => {    
      this.financeData = e
    });
  }

  editMapping() {
    this.editEvent.emit({
      component: SkuMappingEditComponent,
      title: "Edit Mapping",
      id: this.selectedSku.sku,
      mappings: this.mappings,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  updateFbaType() {
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "600px",
        data: {
          title: "Update FBA Type",
          message: "Are you sure you want to update FBA Type?",
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res === "Confirm") {
          this.gridActionsService.updateFbaType([{Sku: this.selectedSku.sku, Account: this.selectedSku.account}], this.shipmentType);
        } else {
          this.shipmentType.setValue(this.selectedSku.fbaType);
        }
      });
  }

  resized(e?) {
    this.gridApi.sizeColumnsToFit();
  }

  updateShipmentIgnore(shipment){
    this.dialog
    .open(ConfirmDialogComponent, {
      width: "600px",
      data: {
        title: "Update Ignore Setting",
        message: `Are you sure you want to include/exclude this Shipment from the forecast?`,
      },
    })
    .afterClosed()
    .pipe()
    .subscribe((confirmation) => {
      if (confirmation === "Confirm") {
        this.ignore = shipment.ignore ? this.ignore = false : this.ignore = true
        const payload:updateIgnorePayload = {
          shipmentHeaderId: shipment.shipmentHeaderId,
          ignore: this.ignore,
          accountType:shipment.accountType
        }
        this.planyardService.UpdateShipmentIgnore(payload).pipe(takeUntil(this.destroy$)).subscribe({
          next: (res) => {
          if(res){
           this.gridApi.refreshServerSide({})
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 4000,
                horizontalPosition: 'center',
                data: {
                  title:'Update shipment Ignore successfully' ,
                  action: 'Dismiss',
                  type: 'success',
                },
              }
            );
          }
        },
         error: (err) => {
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: err.error.error[0],
                action: 'Dismiss',
                type: 'error',
              },
            }
          );
          this.gridApi.refreshServerSide({});
         }
       });
    }else{
      this.gridApi.refreshServerSide({})
    }
  });
}
}
